import { isNil } from 'lodash';

import { CSSProperties } from 'react';

export function Spinner({
    show,
    fontSize,
    styles,
}: {
    show: boolean;
    fontSize?: number;
    styles?: CSSProperties;
}) {
    const styleFontSize = (styles || {}).fontSize;
    const styleDisplay = (styles || {}).display;

    // force display none when show is false, otherwise use what's provided in the style object, otherwise null
    const appliedDisplay = show ? styleDisplay : 'none';
    const appliedFontSize = isNil(fontSize) ? styleFontSize : fontSize;

    return (
        <div
            className="ims-spinner"
            data-testid="Spinner"
            style={{
                // inject any extra styles as you wish
                ...(styles || {}),
                // except for font-size and display, may be forced accordingly
                fontSize: appliedFontSize,
                display: appliedDisplay,
                zIndex: 'inherit',
            }}
        />
    );
}
